const CardHeader = ({ children, className = "" }) => {
  return (
    <div className={`text-center ${className}`}>
      {children}
    </div>
  )
}

export default CardHeader;
